// src/components/CompetitionStatisticsView.js
import React from 'react';
import { Line } from 'react-chartjs-2';
import { Card, Container } from 'react-bootstrap';

const CompetitionStatisticsView = ({ competition, datasets, totalActivities, totalPoints, options, isLoading, error, theme }) => {
    if (isLoading) {
        return <div>Loading competition data...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <Container>
            <Card>
                <Card.Header as="h2">Competition Statistics</Card.Header>
                <Card.Body>
                    <Card.Text>Competition start date: {new Date(competition.startDate).toLocaleDateString()}</Card.Text>
                    <Card.Text>Competition end date: {new Date(competition.endDate).toLocaleDateString()}</Card.Text>
                    <Card.Text>Total competitors: {competition.competitors.length}</Card.Text>
                    <Card.Text>Total activities: {totalActivities}</Card.Text>
                    <Card.Text>Total points: {totalPoints.toFixed(2)}</Card.Text>
                </Card.Body>
                <Line data={{ datasets }} options={options} />
            </Card>
        </Container>
    );
};

export default CompetitionStatisticsView;
